<template>
  <md-button v-if="isVisible" :class="buttonClass" @click="edit">
    <md-tooltip>{{ tooltip }}</md-tooltip>
    <md-icon>create</md-icon>
  </md-button>
</template>

<script>
export default {
  name: "edit-button",
  props: {
    stateId: {
      type: Number,
      default: 1,
      validator: function(value) {
        return [1, 2, 3].indexOf(value) !== -1;
      }
    },
    tooltip: {
      type: String,
      default: "Edit"
    },
    isSmall: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isVisible() {
      if (!this.$auth.isInGlobalRole()) return false;
      else if (this.stateId !== 1) return false;
      return true;
    },
    buttonClass() {
      return !this.isSmall
        ? "md-primary md-just-icon add-button"
        : "md-primary md-just-icon";
    }
  },
  methods: {
    edit() {
      this.$emit("edit-click");
    }
  }
};
</script>

<style>
.add-button {
  float: right;
  margin-top: 10px !important;
}
</style>
